/*
 * @Date: 2020-03-09 18:05:13
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 12:05:48
 * @FilePath: /rongxin.web/src/router/index.js
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home', // 首页
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/productService',
    name: 'productService', // 产品服务
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/productSeviceDetail',
    name: 'productSeviceDetail', // 产品服务二级
    component: () => import('@/views/detail-two/product-sevice-detail/index.vue')
  },
  {
    path: '/productDetailSevice',
    name: 'productDetailSevice', // 产品服务三级
    component: () => import('@/views/detail-three/product-sevice-detail/index.vue')
  },
  {
    path: '/newsCenter',
    name: 'newsCenter', // 企业动态
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/enterpriseNewsDetail',
    name: 'enterpriseNewsDetail', // 企业动态二级
    component: () => import('@/views/detail-two/enterprise-news-detail/index.vue')
  },
  {
    path: '/enterpriseDetailNews',
    name: 'enterpriseDetailNews', // 企业动态三级
    component: () => import('@/views/detail-three/enterprise-news-detail/index.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs', // 关于我们
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/aboutUsDetail',
    name: 'aboutUsDetail', // 关于我们二级
    component: () => import('@/views/detail-two/about-us-detail/index.vue')
  },
  {
    path: '/mediaReports',
    name: 'mediaReports', // 媒体报道
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/mediaReportsDetail',
    name: 'mediaReportsDetail', // 媒体报道二级
    component: () => import('@/views/detail-two/media-reports-detail/index.vue')
  },
  {
    path: '/mediaDetailReports',
    name: 'mediaDetailReports', // 媒体报道三级
    component: () => import('@/views/detail-three/media-reports-detail/index.vue')
  },
  {
    path: '/partner',
    name: 'partner', // 合作伙伴
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/partnerDetail',
    name: 'partnerDetail', // 合作伙伴二级
    component: () => import('@/views/detail-two/partner-detail/index.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs', // 联系我们
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/contactUsDetail',
    name: 'contactUsDetail', // 联系我们二级
    component: () => import('@/views/detail-two/contact-us-detail/index.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacyAgreement', // 隐私协议
    component: () => import('@/views/app/privacy-policy/index.vue')
  }
];

const router = new VueRouter({
  routes
});

export default router;
